"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function Home() {
  const [value, setValue] = useState("");
  const router = useRouter();

  function submit(e: React.FormEvent) {
    e.preventDefault();
    const n = value.trim().toUpperCase();
    if (n) router.push(`/company/${encodeURIComponent(n)}`);
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-xl flex-col justify-center px-4 py-10">
      <h1 className="text-3xl font-bold text-slate-900">Compliance Copilot</h1>
      <p className="mt-2 text-slate-500">
        Enter your company number to see your Companies House deadlines, risks, and
        recent activity — no login, no portal.
      </p>

      <form onSubmit={submit} className="mt-6 flex gap-2">
        <input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="e.g. 16541880"
          aria-label="Company number"
          className="flex-1 rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 outline-none focus:border-slate-500"
        />
        <button
          type="submit"
          className="rounded-lg bg-slate-900 px-5 py-2.5 font-medium text-white hover:bg-slate-700"
        >
          Check
        </button>
      </form>

      <p className="mt-3 text-xs text-slate-400">
        Read-only. We never file anything. Find your number at
        find-and-update.company-information.service.gov.uk
      </p>
    </main>
  );
}
